import React, { useEffect, useState } from 'react';
import { useApi } from '../api';
import {
  Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, TextField, Box,
  Card, useMediaQuery, useTheme
} from '@mui/material';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import { motion } from 'framer-motion';
import { formatearFechaLocal } from './utils';

function obtenerFechaISO(daysAgo = 0) {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return formatearFechaLocal(date);
}

export default function Historial() {
  const [eventos, setEventos] = useState([]);
  const [filtroDesde, setFiltroDesde] = useState(obtenerFechaISO(3));
  const [filtroHasta, setFiltroHasta] = useState(obtenerFechaISO(0));
  const [filtroModulo, setFiltroModulo] = useState('');
  const api = useApi();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const cargarEventos = () => {
    const params = {};
    if (filtroDesde) params.desde = filtroDesde;
    if (filtroHasta) params.hasta = filtroHasta;
    if (filtroModulo) params.modulo = filtroModulo;
    api.get(`${process.env.REACT_APP_API_URL}/api/historial/`, { params })
      .then(res => setEventos(res.data))
      .catch(err => console.error('Error al cargar historial:', err));
  };

  useEffect(() => { cargarEventos(); }, []);
  useEffect(() => { cargarEventos(); }, [filtroDesde, filtroHasta, filtroModulo]);

  return (
    <Paper sx={{ padding: 2 }}>
      {/* Título principal animado */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.6, 0.01, 0.05, 0.95] }}
      >
        <Typography className="titulo-app" variant="h5" gutterBottom>
          <ManageHistoryIcon sx={{ mr: 1, fontSize: 32, color: '#083a94', verticalAlign: 'middle' }} />
          Historial de Actividades
        </Typography>
      </motion.div>

      {/* Sección: Log de auditoría */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.15, ease: [0.6, 0.01, 0.05, 0.95] }}
      >
        <Paper elevation={2} sx={{ p: 2, mb: 3, borderLeft: '4px solid #083a94', borderRadius: 2 }}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
            <TextField
              label="Desde"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filtroDesde}
              onChange={e => setFiltroDesde(e.target.value)}
            />
            <TextField
              label="Hasta"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={filtroHasta}
              onChange={e => setFiltroHasta(e.target.value)}
            />
            <TextField
              label="Módulo"
              placeholder="Ej: Clientes, Ingresos..."
              size="small"
              value={filtroModulo}
              onChange={e => setFiltroModulo(e.target.value)}
            />
          </Box>
          {isMobile ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {eventos.length === 0 ? (
                <Typography color="text.secondary">No hay eventos en el periodo seleccionado.</Typography>
              ) : (
                eventos.map(evento => (
                  <Card key={evento.id} variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="body2" color="text.secondary">{new Date(evento.fecha).toLocaleString()}</Typography>
                    <Typography sx={{ fontWeight: 700 }}>{evento.usuario} · {evento.accion}</Typography>
                    <Typography variant="body2" color="text.secondary">Módulo: {evento.modulo}</Typography>
                    {evento.detalle && (
                      <Typography variant="body2" sx={{ mt: 0.5 }}>{evento.detalle}</Typography>
                    )}
                  </Card>
                ))
              )}
            </Box>
          ) : (
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ background: '#083a94' }}>
                  {['Fecha', 'Usuario', 'Acción', 'Módulo', 'Detalle'].map(h => (
                    <TableCell key={h} sx={{ color: 'white', fontWeight: 'bold' }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {eventos.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No hay eventos en el periodo seleccionado.
                    </TableCell>
                  </TableRow>
                ) : eventos.map(evento => (
                  <TableRow key={evento.id} hover>
                    <TableCell>{new Date(evento.fecha).toLocaleString()}</TableCell>
                    <TableCell>{evento.usuario}</TableCell>
                    <TableCell>{evento.accion}</TableCell>
                    <TableCell>{evento.modulo}</TableCell>
                    <TableCell>{evento.detalle}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          )}
        </Paper>
      </motion.div>
    </Paper>
  );
}
